import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actionCreator from "../../../redux/action/actionCreator";

// core-components

import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/ReportsForm";
import { CREATE_REPORT, UPDATE_REPORT } from "../../../redux/reports/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchReportData } from "../../../redux/reports";
import { useNavigate } from "react-router";

export default (props) => {
  const { reportId } = props;
  const dispatch = useDispatch();

  const operationStore = useSelector((store) =>
    reportId ? store.updateReportGlobalStore : store.createReportGlobalStore
  );
  const [state, setState] = useState({
    openToast: false,
  });
  const reportData = useSelector((state) => state.reportGlobalStore);

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  useEffect(() => {
    if (reportId) {
      dispatch(fetchReportData(reportId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, summary, category, date, fileUrl } = formData;
    if ((!title, !summary, !category, !date, !fileUrl) && !reportId) {
      return openToast({
        message: `Please Enter All required fields \nMissing: ${
          (!title && "Title",
          !summary && "Summary",
          !category && "Category",
          !date && "No date chosen",
          !fileUrl && "File not uploaded")
        }`,
        type: "warning",
      });
    }
    const reportInfo = {
      title,
      summary,
      category,
      date,
      pdfUrl: fileUrl || "",
      authorId: "",
    };
    await toast.promise(
      dispatch(
        actionCreator({
          method: reportId ? "PATCH" : "POST",
          path: reportId ? `/api/reports/${reportId}` : "/api/reports",
          actionType: reportId ? UPDATE_REPORT : CREATE_REPORT,
          data: reportInfo,
        })
      ),
      {
        pending: `${!reportId ? "Creating" : "Updating"} report`,
      }
    );

    setState({ ...state, openToast: true });
  };

  const navigate = useNavigate();

  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        operationStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }

  const crumps = [
    {
      title: "Reports",
      path: "/reports",
    },
  ];

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {reportId && reportData.loading ? (
        <Loading />
      ) : (
        <div>
          <CreateForm
            isCreate={reportId ? false : true}
            title="Create a Report"
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseContentData={reportId ? reportData.data : {}}
            isLoading={operationStore.loading}
          />
        </div>
      )}
    </div>
  );
};
